import { PlaceInAkixiNameSpace } from './Utils'

// Timeout before the update cycle is resumed.
const RESUME_UPDATE_TIMEOUT: number = 60000

// Get the pause variable from the Akixi global namespace.
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isContentPaused = (): boolean => com.Akixi.PauseReportXMLContentUpdates as boolean

// Set the pause variable within the Akixi global namespace.
const setPauseReportXMLContentUpdates = (pause: boolean): void => {
    PlaceInAkixiNameSpace('PauseReportXMLContentUpdates', pause)
}

// Resume the once per second XML content updates.
export const resumeReportXMLContentUpdates = (): void => {
    setPauseReportXMLContentUpdates(false)
}

// Pause the once per second XML content updates.
export const pauseReportXMLContentUpdates = (): void => {
    if (!isContentPaused()) {
        setPauseReportXMLContentUpdates(true)
        setTimeout(resumeReportXMLContentUpdates, RESUME_UPDATE_TIMEOUT)
    }
}

// Add the functions to the Akixi global namespace.
if (!isContentPaused()) {
    PlaceInAkixiNameSpace('SetPauseReportXMLContentUpdates', pauseReportXMLContentUpdates)
    PlaceInAkixiNameSpace('ResumeReportXMLUpdates', resumeReportXMLContentUpdates)
}
